module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4Qy0L"))).then(() => parcelRequire('d0iPb'));